export default "__VITE_ASSET__TkPsm1mp__"